export default "__VITE_ASSET__CrTl6UTF__"